import type { RouteComponentProps } from "react-router-dom";

import type { BreadcrumbTrailItem } from "~/common/redesign-v1";

import { createRedesignEntry } from "../redesign-page-entry";

/** Route entries that render adapters from `./adopted-routes` inside the redesign shell. */

type PatientRoute = RouteComponentProps<{ patient_id: string }>;

function patientTrail(patientId: string | undefined): BreadcrumbTrailItem[] | undefined {
  if (!patientId) return undefined;
  return [{ id: "redesign.shell.patient", defaultMessage: "Patient {id}", values: { id: patientId }, to: `/pages/patient/${patientId}` }];
}

/* ── A. Online payment ──────────────────────────────────────────────────────────────────────── */

export const PaymentInvoiceRedesignEntry = createRedesignEntry<PatientRoute>(async () => ({ default: (await import("./adopted-routes")).PaymentInvoiceRedesign }), {
  testId: "rd-payment-invoice-loading",
  shell: (props) => ({
    activeNav: "payments",
    breadcrumbTrail: patientTrail(props.match?.params?.patient_id),
    breadcrumbLeaf: { id: "redesign.shell.online_payment", defaultMessage: "Online payment" },
  }),
});

export const PaymentInvoiceSuccessRedesignEntry = createRedesignEntry(async () => ({ default: (await import("./adopted-routes")).PaymentInvoiceSuccessRedesign }), {
  testId: "rd-payment-success-loading",
  shell: { activeNav: "payments", breadcrumbLeaf: { id: "redesign.shell.online_payment", defaultMessage: "Online payment" } },
});

export const PaymentInvoiceErrorRedesignEntry = createRedesignEntry(async () => ({ default: (await import("./adopted-routes")).PaymentInvoiceErrorRedesign }), {
  testId: "rd-payment-error-loading",
  shell: { activeNav: "payments", breadcrumbLeaf: { id: "redesign.shell.online_payment", defaultMessage: "Online payment" } },
});

/* ── B. Doctor pages ────────────────────────────────────────────────────────────────────────── */

export const PatientsTasksRedesignEntry = createRedesignEntry<RouteComponentProps>(async () => ({ default: (await import("./adopted-routes")).PatientsTasksRedesign }), {
  testId: "rd-tasks-loading",
  shell: { activeNav: "patients", breadcrumbLeaf: { id: "pat_table_tasks.block_head", defaultMessage: "Current tasks" } },
});

export const ClinicsListRedesignEntry = createRedesignEntry(async () => ({ default: (await import("./adopted-routes")).ClinicsListRedesign }), {
  testId: "rd-clinics-list-loading",
  shell: {
    breadcrumbRoot: { id: "redesign.profile.title", defaultMessage: "My profile", to: "/pages/my_account" },
    breadcrumbLeaf: { id: "redesign.profile.section.clinics", defaultMessage: "My clinics" },
  },
});

export const EliteRedesignEntry = createRedesignEntry(async () => ({ default: (await import("./adopted-routes")).EliteRedesign }), {
  testId: "rd-elite-loading",
  shell: { breadcrumbLeaf: { id: "redesign.shell.elite", defaultMessage: "3D Smile Elite" } },
});

export const ElitePaymentStatusRedesignEntry = createRedesignEntry(async () => ({ default: (await import("./adopted-routes")).ElitePaymentStatusRedesign }), {
  testId: "rd-elite-payment-loading",
  shell: { breadcrumbLeaf: { id: "redesign.shell.elite", defaultMessage: "3D Smile Elite" } },
});

export const HomeRedesignEntry = createRedesignEntry(async () => ({ default: (await import("./adopted-routes")).HomeRedesign }), {
  testId: "rd-home-loading",
  shell: { breadcrumbLeaf: { id: "pat_table.block_banners", defaultMessage: "News" } },
});
